import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseBlock, { TitleBlock } from '../ui/Block';
import { PageContainer } from '../ui/Container';
import useReports from './context/useReports';
import CreateReportModal from './CreateReportModal';
import NewReportButtonDashboard from './NewReportButtonDashboard';
import ReportCard from './ReportCard';
import { NewProjectBlock } from '../dashboard/blocks/model';
import { Add } from '@mui/icons-material';
import Markdown from '../ui/Markdown';

const Block = styled(BaseBlock)`
  padding: 16px;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
`;


const Results = () => {
  const { t } = useTranslation([
    'dashboard',
    'common',
    'annual-reports',
    'model',
  ]);
  const navigate = useNavigate();
  const { reports, remove } = useReports();
  const [open, setOpen] = useState(false);

  if (!reports) return null;

  const handleNewProjectClicked = () => {
    setOpen(true);
  };

  const handleReportClicked = (reportId: string) => () => {
    navigate(`/annual-reports/${reportId}`);
  };

  const handleReportDeleted = (reportId: string) => async (event: any) => {
    return await remove(reportId);
  };

  return (
    <PageContainer>
      <TitleBlock background="var(--color-primary)" color="var(--TEAROSE)">
        <h3>{t('annual-reports:title')}</h3>
        <p>{t('annual-reports:subtitle')}</p>
      </TitleBlock>
      {reports.length === 0 && <TitleBlock background="var(--TEAROSE)" color="black">
        <Markdown>{t('annual-reports:creation-modal.explanation')}</Markdown>
      </TitleBlock>}
      <CreateReportModal
        open={open}
        setOpen={setOpen}
        onClose={() => {
          setOpen(false);
        }}
      />
      <Block>
        <NewProjectBlock onClick={handleNewProjectClicked} color="#FFFFFF">
          <Add />
        </NewProjectBlock>
        {reports.map((report) => (
          <ReportCard
            report={report}
            key={report._id.toString()}
            onClick={handleReportClicked(report._id.toString())}
            onDelete={handleReportDeleted(report._id.toString())}
          />
        ))}
      </Block>
    </PageContainer>
  );
};

export default Results;
